import axios from "axios";

export default class AvailabilityService {
  static getAvailabilityCruise(month, year, yacht, itinerary) {
    return axios.get(

      "availablecruises" +
      `?month=${month}&&year=${year}&&yacht=${yacht}&&itinerary=${itinerary}`
    );
  }

  static insertAvailabilityCruise(payload) {
    return axios.post("b2b/availablecruises", payload);
  }

  static insertAvailabilityCruiseCharter(payload) {
    return axios.post("b2b/availablecruises/charter", payload);
  }

  static getActualReservationByAgency(agencyId) {
    return axios.get(
      `b2b/actualReservations?agency_id=${agencyId}`
    );
  }

  static getHistoricalReservationByAgency(agencyId) {
    return axios.get(
      `b2b/historicalReservations?agency_id=${agencyId}`
    );
  }

  static getReservationDetail(reservationId) {
    return axios.get(`b2b/spacesByReservation/${reservationId}`);
  }

  static changeSpacesOfAReservation(payload) {
    return axios.post(`b2b/changeSpace`, payload);
  }

  static postSpacesAndPassengers(payload) {
    return axios.post(
      `b2b/spacesAndPassengersByReservation`,
      payload
    );
  }
}
